import Heading from 'components/typography/heading'
import Paragraph from 'components/typography/paragraph'
import styled from 'styled-components'

export const FormActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
`

export const StyledHeading = styled(Heading)`
margin-bottom: 2rem;
`
export const StyledParagraph = styled(Paragraph)`
margin-bottom: 2rem;
`
export const StyledFormContainer = styled.div`
height: 100%;
`

export const StyledForm = styled.form`
height: 100%;
display: grid;
grid-template-rows: 1fr auto;
grid-template-columns: 1fr;
justify-content: space-between;
gap: 1rem;
`

export const StyledPageHeader = styled.div`
display: grid;
grid-template-columns: 1fr auto;
justify-content: space-between;
gap: 5rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`

export const StyledProcessText = styled(Paragraph)`
opacity: 0.7;
    text-align: right;
    font-size: 14px;
`
